import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import MainHeader from "../../Pages/Header/HeaderForBus";
import FooterStyle from "../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import API from '../../Api/Api';
import { IMAGE_PATHS, base64Encode } from "../../Functions/Constant";
import ConfinPop from "../../Pages/ComponentPage/ConfinPop";
import UserCard from './CommanBox';
import LimitExtendPop from "../../Pages/ComponentPage/LimitExtendPop";

const SearchForm = () => {
    const location = useLocation();
    const [visibleItems, setVisibleItems] = useState(5);
    const [queryString, setQueryString] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const [topResults, setTopResults] = useState([]);
    const [bestMatches, setBestMatches] = useState([]);
    const [moreSuggestions, setMoreSuggestions] = useState([]);
    const [recentSearches, setRecentSearches] = useState([]);
    const [focusedField, setFocusedField] = useState(null);
    const [filters, setFilters] = useState({
        name: "",
        company: "",
        school: "",
        location: "",
        phone: "",
    });
    const [inputFilters, setInputFilters] = useState({
        name: "",
        company: "",
        school: "",
        location: "",
        phone: "",
    });
    const [loading, setLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    let userData;
    try {
      userData = JSON.parse(localStorage.getItem("userData") || "{}");
    } catch (error) {
      console.error("Error parsing userData from localStorage:", error);
      userData = {};
    }

    const getQueryParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams;
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setInputFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const fetchUsers = async (reset = false) => {
        if (isFetching || (page > totalPages && !reset)) return;
        setIsFetching(true);
        setLoading(true);
        try {
            const payload = {
                name: filters.name,
                company: filters.company,
                school: filters.school,
                location: filters.location,
                phone: filters.phone,
                page: Math.max(1, page),
                limit: 10,
                sortBy: "name",
            };
            const response = await API.post('/business/search-user', payload);
            if (response.success) {
                setTopResults((prev) => reset ? response.users.topResults : [...prev, ...response.users.topResults]);
                setBestMatches((prev) => reset ? response.users.bestMatches : [...prev, ...response.users.bestMatches]);
                setMoreSuggestions((prev) => reset ? response.users.moreSuggestions : [...prev, ...response.users.moreSuggestions]);
                setTotalPages(response.pagination.totalPages);
                if (response.recentSearches.length > 0) {
                    recentApiSearches(response.recentSearches[0]);
                }
                if (!reset) setPage((prev) => prev + 1);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
            setIsFetching(false);
        }
    };

    const recentApiSearches = async (payload) => {
        setLoading(true);
        try {
            const response = await API.post('/business/recentsearch-user', payload);
            if (response.success) {
                setRecentSearches(response.users);
            }
        } catch (error) {
            console.error("Error fetching recent searches:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchFirstTimeUsers = async (payload) => {
        setLoading(true);
        try {
            const response = await API.post('/business/search-user', payload);
            if (response.success) {
                setTopResults(response.users.topResults);
                setBestMatches(response.users.bestMatches);
                setMoreSuggestions(response.users.moreSuggestions);
                setTotalPages(response.pagination.totalPages);
                if (response.recentSearches.length > 0) {
                    recentApiSearches(response.recentSearches[0]);
                }
                setPage(1);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };
    const rateNow = async () => {
        if (!selectedUser) return;
        const payload = {
            target_user_id: selectedUser.user_id,
        };
        try {
           const res = await API.post('/business/initiate-verification', payload);
            if (res.error_type == 1) {
                setIsExtendOpen(true);
            } else {
                localStorage.removeItem("userData");
                window.location.href = `/profile/${selectedUser.name.replace(/\s+/g, '-').toLowerCase()}/${base64Encode(selectedUser.user_id)}`;
            }
        } catch (error) {
            console.error("Error initiating rating:", error);
        } finally {
            setIsPopupOpen(false);
            setSelectedUser(null);
        }
    };

    const viewUser = async (user) => {
        try {
            window.location.href = `/profile/${user.name.replace(/\s+/g, '-').toLowerCase()}/${base64Encode(user.user_id)}`;
        } catch (error) {
            console.error("Error viewing user:", error);
        }
    };

    const handleFilterSubmit = (e) => {
        const { name } = e.target;
        if (name === "name") {
            const value = inputFilters[name];
            navigate(`/search-employee?query=${encodeURIComponent(value)}`);
            setFilters((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setFilters((prev) => ({
                ...prev,
                [name]: inputFilters[name],
            }));
        }
        setPage(1);
    };

    useEffect(() => {
        fetchUsers(true);
    }, [filters]);

    useEffect(() => {
        const searchParams = getQueryParams();
        const value = searchParams.get("query");
        const type = searchParams.get("category");
        setQueryString(value);
        if (type == "name") {
            setFilters((prev) => ({
                ...prev,
                name: value,
            }));
            setInputFilters((prev) => ({
                ...prev,
                name: value,
            }));
        } else if (type == "company") {
            setFilters((prev) => ({
                ...prev,
                company: value,
            }));
            setInputFilters((prev) => ({
                ...prev,
                company: value,
            }));
        } else if (type == "school") {
            setFilters((prev) => ({
                ...prev,
                school: value,
            }));
            setInputFilters((prev) => ({
                ...prev,
                school: value,
            }));
        } else if (type == "location") {
            setFilters((prev) => ({
                ...prev,
                location: value,
            }));
            setInputFilters((prev) => ({
                ...prev,
                location: value,
            }));
        } else if (type == "contact") {
            setFilters((prev) => ({
                ...prev,
                phone: value,
            }));
            setInputFilters((prev) => ({
                ...prev,
                phone: value,
            }));
        }
        const payload = {
            name: type === "name" ? value : filters.name,
            company: type === "company" ? value : filters.company,
            school: type === "school" ? value : filters.school,
            location: type === "location" ? value : filters.location,
            phone: type === "contact" ? value : filters.phone,
            page: 1,
            limit: 10,
            sortBy: "name",
        };
        fetchFirstTimeUsers(payload);
    }, [location.search]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isExtendOpen, setIsExtendOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const handleRateNow = (user) => {
        if (userData?.credit_balance <= 0) {
            setIsExtendOpen(true);
        } else {
            setSelectedUser(user);
            setIsPopupOpen(true);
        }
    };
    return (
        <div>
            <MainHeader />
            <section className="pb-[100px] px-4 pt-[120px] sm:pb-[60px] sm:pt-[60px] md:pb-[60px] md:pt-[60px] custm-bg">
                <Container>

                    <Row className="relative">
                        <Col lg={3} md={12} sm={12} className="mb-4 sm:p-0 md:p-0">

                            <div className="sticky top-[28px]">
                                <div className="p-4 border rounded-lg bg-white">
                                    <h3 className="text-[22px] font-bold text-black mb-[14px] leading-[1.5]">
                                        Search Candidates for Verification
                                    </h3>
                                    <hr className="border-gray-300 mb-4 hrb" />
                                    <h4 className="text-lg font-bold mb-4 text-black mt-[40px]">Filters</h4>
                                    {["name", "phone", "company", "school", "location"].map((field) => {
                                        const isCompanyDisabled =
                                            field === "company" &&
                                            (focusedField === "school" ||
                                                filters.school.trim() !== "" ||
                                                inputFilters.school.trim() !== "");
                                        const isSchoolDisabled =
                                            field === "school" &&
                                            (focusedField === "company" ||
                                                filters.company.trim() !== "" ||
                                                inputFilters.company.trim() !== "");

                                        const placeholderMap = {
                                            name: "Search by name",
                                            phone: "Search by phone/email",
                                            company: "Search by company",
                                            school: "Search by school/college",
                                            location: "Search by location",
                                        };

                                        return (
                                            <div className="mb-3" key={field}>
                                                <label className="block text-[15px] font-semibold text-gray-600">
                                                    {field === "school"
                                                        ? "School/College"
                                                        : field === "phone"
                                                            ? "Contact"
                                                            : field.charAt(0).toUpperCase() + field.slice(1)}
                                                </label>
                                                {filters[field].trim() !== "" ? (
                                                    <div className="flex items-baseline justify-between px-3 py-2 border border-gray-300 rounded-md bg-gray-100">
                                                        <span className="text-sm text-gray-800 truncate">{filters[field]}</span>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (field === "company" || field === "school") {
                                                                    // Clear both company and school fields and reset focus
                                                                    setFilters((prev) => ({
                                                                        ...prev,
                                                                        company: "",
                                                                        school: "",
                                                                    }));
                                                                    setInputFilters((prev) => ({
                                                                        ...prev,
                                                                        company: "",
                                                                        school: "",
                                                                    }));
                                                                    setFocusedField(null); // Reset focus to ensure no field is disabled
                                                                } else {
                                                                    // Clear only the specific field for other fields
                                                                    setFilters((prev) => ({
                                                                        ...prev,
                                                                        [field]: "",
                                                                    }));
                                                                    setInputFilters((prev) => ({
                                                                        ...prev,
                                                                        [field]: "",
                                                                    }));
                                                                }
                                                                setPage(1);
                                                            }}
                                                            className="ml-2 text-gray-500 hover:text-red-500 text-sm font-bold"
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <input
                                                        type={field === "phone" ? "tel" : "text"}
                                                        name={field}
                                                        value={inputFilters[field]}
                                                        onChange={handleFilterChange}
                                                        onFocus={() => setFocusedField(field)}
                                                        onBlur={() => setFocusedField(null)}
                                                        className="form-control fomc-cls px-3 py-2 w-full appearance-none border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        placeholder={placeholderMap[field]}
                                                        disabled={isCompanyDisabled || isSchoolDisabled}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                handleFilterSubmit({ target: { name: field, value: inputFilters[field] } });
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                        </Col>

                        <Col lg={9} md={12} sm={12} className="md:p-0">
                            {topResults.length === 0 && moreSuggestions.length === 0 && bestMatches.length === 0 && recentSearches.length === 0 ? (
                                <div className="p-6 text-center">
                                    <img
                                        src={IMAGE_PATHS.RateForm}
                                        alt="No matches"
                                        className="mx-auto mb-2 object-cover rounded"
                                        width="300px"
                                    />
                                    <p className="text-gray-400 mb-2 font-extrabold text-lg">No Match Found</p>
                                    <p className="text-black text-[22px] font-extrabold mb-2">Search for a candidate to view detailed profiles and ratings.</p>
                                    <p className="text-bold text-gray-900 mb-3 text-[20px]">
                                        You can search by name, contact details, education, work history, or city - and we'll fetch the best possible matches for you.
                                    </p>
                                </div>
                            ) : (
                                <Row>
                                    {topResults.length > 0 && (
                                        <>
                                            <h3 className="text-[22px] font-bold text-black mb-2 leading-[1.5]">
                                                Top Results:
                                            </h3>
                                            {topResults.map((user, index) => (
                                                <Col lg={6} md={6} sm={12} key={index} className="mb-4">
                                                    <UserCard user={user} viewUser={viewUser} rateNow={handleRateNow} />
                                                </Col>
                                            ))}
                                        </>
                                    )}

                                    {bestMatches.length > 0 && (
                                        <>
                                            <h3 className="text-[22px] font-bold text-black mb-2 leading-[1.5]">
                                                Best Matches:
                                            </h3>
                                            {bestMatches.slice(0, visibleItems).map((user, index) => (
                                                <Col lg={6} md={6} sm={12} key={index} className="mb-4">
                                                    <UserCard user={user} viewUser={viewUser} rateNow={handleRateNow} />
                                                </Col>
                                            ))}
                                        </>
                                    )}
                                    {moreSuggestions.length > 0 && (
                                        <>
                                            <h3 className={`text-[22px] font-bold text-black mb-2 leading-[1.5] ${ bestMatches.length > 0 || topResults.length > 0 ? "mt-[38px]" : ""}`}>
                                                More Suggestions:
                                            </h3>
                                            {moreSuggestions.slice(0, visibleItems).map((user, index) => (
                                                <Col lg={6} md={6} sm={12} key={index} className="mb-4">
                                                    <UserCard user={user} viewUser={viewUser} rateNow={handleRateNow} />
                                                </Col>
                                            ))}
                                        </>
                                    )}
                                    {recentSearches.length > 0 && (
                                        <>
                                            <h3 className={`text-[26px] font-bold text-black mb-2 leading-[1.5] ${moreSuggestions.length > 0 || bestMatches.length > 0 || topResults.length > 0 ? "mt-[38px]" : ""}`}>
                                                Recent Searches:
                                            </h3>
                                            {recentSearches.slice(0, visibleItems).map((user, index) => (
                                                <Col lg={6} md={6} sm={12} key={index} className="mb-4">
                                                    <UserCard user={user} viewUser={viewUser} rateNow={handleRateNow} />
                                                </Col>
                                            ))}
                                        </>
                                    )}
                                </Row>
                            )}
                        </Col>
                    </Row>
                </Container>
            </section>
            <ConfinPop
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                onConfirm={rateNow}
            />
            <LimitExtendPop
                isOpen={isExtendOpen}
                onClose={() => setIsExtendOpen(false)}
            />
            <FooterStyle theme="light" className="bg-black text-[#828282]" />

        </div>
    );
};

export default SearchForm;